import { LessonItem } from "@/components/ui/curriculum/lesson-item"

interface Lesson {
  id: number
  title: string
  duration: string
  isActive: boolean
  isLocked: boolean
}

interface CourseOutlineProps {
  lessons: Lesson[]
}

export function CourseOutline({ lessons }: CourseOutlineProps) {
  return (
    <div className="flex flex-col border-l border-border bg-slate-200">
      {/* Header */}
      <div className="flex-shrink-0 p-6 border-b border-border">
        <h3 className="text-xl text-gray-800 font-bold">Course Outline</h3>
      </div>

      {/* Scrollable content */}
      <div className="flex-1 overflow-y-auto">
        <div className="px-6 py-6 flex flex-col gap-3">
          {lessons.map((lesson) => (
            <LessonItem
              key={lesson.id}
              lessonNumber={lesson.id}
              title={lesson.title}
              duration={lesson.duration}
              isActive={lesson.isActive}
              isLocked={lesson.isLocked}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
